export let SecurityCenterStateKeys;
(function (SecurityCenterStateKeys) {
  SecurityCenterStateKeys["RECOMMENDATIONS"] = "recommendations";
  SecurityCenterStateKeys["INSIGHTS"] = "insights";
  SecurityCenterStateKeys["SEND_BULK_RESET_BREACHED_PASSWORD_EMAILS"] = "sendBulkResetBreachedPasswordEmails";
  SecurityCenterStateKeys["SEND_BREACHED_PASSWORD_EMAIL"] = "sendBreachedPasswordEmail";
  SecurityCenterStateKeys["BREACHED_PASSWORD_USERS_TABLE"] = "breachedPasswordUsersTable";
  SecurityCenterStateKeys["UNENROLLED_MFA_USERS_TABLE"] = "unenrolledMfaUsersTable";
  SecurityCenterStateKeys["INACTIVE_USERS_TABLE"] = "inactiveUsersTable";
})(SecurityCenterStateKeys || (SecurityCenterStateKeys = {}));